export const questionConditionOptions = [
    { id: "GqlSettingsFormTemplateQuestionConditionNone", translationKey: "formTemplateQuestionForm.conditionNone" },
    {
        id: "GqlSettingsFormTemplateQuestionConditionIsEqual",
        translationKey: "formTemplateQuestionForm.conditionIsEqual",
    },
    { id: "GqlSettingsFormTemplateQuestionConditionOr", translationKey: "formTemplateQuestionForm.conditionOr" },
];
